import { InitialProfile } from "../services/Contract.service";

export const ProfilesMap: InitialProfile[] = [
    {
        compute:'1',
        bandwidth:'1',
        disk:'0'
    },
    {
        compute:'0', // profile 1 - 1gb1vcpu10mb50gb
        bandwidth:'0',
        disk:'0'
    },
    {
        compute:'2', //profile 2 - 2gb2vcpu20mb50gb
        bandwidth:'1',
        disk:'0'
    },
    {
        compute:'4', //profile 3 - 4gb4vcpu30mb50gb
        bandwidth:'2',
        disk:'0'
    },
    {
        compute:'6', //profile 4 - 8gb8vcpu50mb70gb
        bandwidth:'2',
        disk:'1'
    },
    { 
        compute:'7', //profile 5 - 16gb8vcpu70mb80gb
        bandwidth:'6',
        disk:'3'
    },
    {
        compute:'5',
        bandwidth:'6',
        disk:'3'
    },
    {
        compute:'6',
        bandwidth:'4',
        disk:'2'
    },
    {
        compute:'8',
        bandwidth:'7',
        disk:'4'
    },
    {
        compute:'7',
        bandwidth:'5',
        disk:'2'
    }
]